<script setup lang="ts">
import { computed } from 'vue'

import { Button, Icon, Overlay } from '@collector/shared-ui'
import {
  CommonEventDetailId,
  Participant,
} from '@collector/sportsapi-client-legacy'
import { useEventDetails } from '@desktop/views/Relation/composables'
import { useProbableLineupDeferredClear } from '@desktop/views/Relation/Sports/composables/useProbableLineupDeferredClear'

type Props = {
  participant: Participant
}
const props = defineProps<Props>()

// emits
type Emits = {
  clear: []
}
const emit = defineEmits<Emits>()

// composables
const { getEventDetailValue } = useEventDetails()
const { clearLineupsLocally } = useProbableLineupDeferredClear()

// computed
const isClearable = computed(
  () =>
    getEventDetailValue(CommonEventDetailId.HasLineups) === 'probable' &&
    props.participant.lineups_copied,
)

// methods
function clearLineups(): void {
  clearLineupsLocally()
  emit('clear')
}
</script>

<template>
  <Overlay
    class="-mx-4 -mt-3"
    centered
    style="width: calc(100% + 2rem); height: calc(100% + 1rem)"
    :modelValue="isClearable"
    scrim="md"
  >
    <div
      class="bg-neutral-light-9 m-4 flex max-w-[28rem] flex-col items-center gap-4 rounded-md p-4 text-center"
    >
      <div
        class="text-success-2 bg-success-9 flex size-16 items-center justify-center rounded-full p-2 text-4xl"
        :rounded="false"
      >
        <Icon icon="users" />
      </div>
      <div class="text-xl font-bold">
        Use the "clear lineup" button to delete probable lineup set for this
        team
      </div>
      <Button
        class="text-neutral-light-10 bg-success-2 hover:bg-success-4 active:bg-success-5 min-w-28 !px-4 text-lg font-bold active:transition-none"
        size="sm"
        @click="clearLineups"
      >
        Clear lineup
      </Button>
    </div>
  </Overlay>
</template>
